import React from "react";

import { UserEntityForm, UserFormProps } from "Bands/components";
import { fields } from "./formData";

export const UserAddressForm: React.FC<UserFormProps> = ({ ...rest }) => {
  return <UserEntityForm fields={fields} style={{ gridTemplateColumns: "1fr" }} {...rest} />;
};
